import styled from 'styled-components';
import { Select } from 'antd';

interface ShowSelectProps {
  collapsed: boolean;
}
interface ContainerSelectInscricoesProps {
  collapsed: boolean;
}
interface ShowOptionsProps {
  showiconclose: boolean;
}

export const BoxSelects = styled.div<ShowSelectProps>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const BtnSelectAll = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    margin: 2px 4px;
  }
`;

export const ContainerSelectInscricoes = styled.div<ContainerSelectInscricoesProps>`
  width: 372px;
  background: ${(props) => props.theme.colors.primary};
  border-radius: 2px;
  position: absolute;
  top: 50px;
  z-index: 9;
  display: ${(props) => (!props.collapsed ? 'none' : 'block')};
  padding: 1rem;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  line-height: 2rem;
  h4 {
    color: ${(props) => props.theme.colors.textPrimary};
  }
  @media (max-width: 815px) {
    left: 0;
    right: 0;
    width: 100%;
  }
`;

export const Overlay = styled.div<ContainerSelectInscricoesProps>`
  display: ${(props) => (!props.collapsed ? 'none' : 'block')};
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 8;
`;

export const SelectResponsive = styled(Select)<ShowOptionsProps>`
  display: block;
  width: 100%;

  .ant-select-selection-item-remove {
    display: ${(props) => (props.showiconclose ? 'none' : 'block')};
  }
  .ant-select-item-option-selected {
    pointer-events: ${(props) => (props.showiconclose ? 'none' : 'visible')};
  }

  span.ant-select-selection-item-content {
    max-width: 200px;
    background-color: ${(props) => props.theme.colors.inputSelect};
  }

  @media (max-width: 815px) {
    width: 100%;
  }
`;

export const SelectResponsiveCDD = styled(Select)`
  display: block;
  width: 100%;
`;
